import React from "react";
import Chips from "storybookComponents/Chips";
import Button from "storybookComponents/Button";
import Expansion from "components/Expansion";
import { isEmail } from "../utils";
import RightContent from "../components/rightSection";

const ApprovedAgents = ({ classes, approvedAgentsData, onSave, event }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [approvedAgents, setApprovedAgents] = React.useState([]);
  const [validate, setValidate] = React.useState(false);

  const handleExpandedPanel = () => setExpanded(!expanded);

  const handleData = (data) => setApprovedAgents(data);

  const validation = () => {
    for (const item of approvedAgents) {
      if (!isEmail(item)) return false;
    }
    return true;
  };

  const handleSave = () => {
    onSave({ agentApprovalEmails: approvedAgents });
  };

  const renderRightContent = (open) => {
    if (open) return null;
    return <RightContent classes={classes} list={approvedAgents} />;
  };

  const renderHeaderIcon = (open) => {
    if (open) return null;
    return <div className={classes.numberWrapper}>{approvedAgents.length}</div>;
  };

  const renderContent = () => (
    <div className={classes.collapseContentWrapper}>
      <div className={classes.text1}>Please add agents who do NOT need approval</div>

      <Chips
        propValues={approvedAgents}
        label="Email(s)"
        onChangeCallback={handleData}
        helperText="Press ‘Enter’ or ‘Comma’ to add multiple emails"
        placeholder=""
        className={classes.chipsWrapper}
        validator={isEmail}
      />

      <div className={classes.text2}>
        By default, all agents need approval to schedule an {event ? "event" : "e-blast"}. For
        agents whom you want to skip approval process, please add them here.
      </div>

      <div className={classes.btnWrapper}>
        <Button
          className={classes.btn}
          state={validate && approvedAgents.join() !== approvedAgentsData.join() ? "" : "inactive"}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </div>
  );

  React.useEffect(() => {
    if (approvedAgentsData) setApprovedAgents(approvedAgentsData);
  }, [approvedAgentsData]);

  React.useEffect(() => {
    setValidate(validation());
  }, [approvedAgents]);

  return (
    <Expansion
      handleExpandedPanel={handleExpandedPanel}
      expanded={expanded}
      header="Approved Agents"
      headerIcon={renderHeaderIcon}
      rightSection={renderRightContent}
    >
      {renderContent()}
    </Expansion>
  );
};

export default ApprovedAgents;
